/**
 * APIを叩いて簡易気象系のデータを取得し、そのデータをDOMに反映
 * @param {Number} item_id
 * @returns {void}
 */
import Cookies from 'js-cookie'

function getWeatherData(item_id) {
    const url = apiDomain + '/api/simple_weather/' + item_id;
    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: url,
        type: 'POST',
        dataType: 'json',
        success: function (data) {
            var device_code = data.data['device_code'];
            var temp = data.data['temp'];
            var humi = data.data['humi'];
            var winddir = data.data['winddir'];
            var windspd = data.data['windspd'];
            var gustspd = data.data['gustspd'];
            var rain_hour1 = data.data['rainHour1'];
            var rain_hour24 = data.data['rainHour24'];
            var simwea_date = data.data['meas_date'];
            var wbgt = data.data['wbgt'];

            var temp_url = data.data['images']['temp'];
            var humi_url = data.data['images']['humi'];
            var winddir_url = data.data['images']['winddir'];
            var windspd_url = data.data['images']['windspd'];
            var gustspd_url = data.data['images']['gustspd'];
            var rain_hour1_url = data.data['images']['rainHour1'];
            var rain_hour24_url = data.data['images']['rainHour24'];
            var wbgt_url = data.data['images']['wbgt'];

            if (wbgt === 0 || wbgt == null) {
                wbgt = '--';
            }
            if (temp == null) {
                temp = '--';
            }
            if (humi == null) {
                humi = '--';
            }
            if (windspd == null) {
                windspd = 0;
            }
            if (gustspd == null) {
                gustspd = 0;
            }
            if (rain_hour1 == null) {
                rain_hour1 = 0;
            }
            if (rain_hour24 == null) {
                rain_hour24 = 0;
            }

            $('.temp_v_' + device_code).text(temp);
            $('.humi_v_' + device_code).text(humi);
            $('.winddir_v_' + device_code).text(winddir);
            $('.windspd_v_' + device_code).text(windspd);
            $('.gustspd_v_' + device_code).text(gustspd);
            $('.wbgt_v_' + device_code).text(wbgt);
            $('.rain_hour1_v_' + device_code).text(('  ' + rain_hour1).slice(-3));
            $('.rain_hour24_v_' + device_code).text(('  ' + rain_hour24).slice(-3));
            $('.simwea_date_v_' + device_code).text(simwea_date);

            $('.temp_url_' + device_code + ' img').attr('src', temp_url);
            $('.humi_url_' + device_code + ' img').attr('src', humi_url);
            $('.winddir_url_' + device_code + ' img').attr('src', winddir_url);
            $('.windspd_url_' + device_code + ' img').attr('src', windspd_url);
            $('.gustspd_url_' + device_code + ' img').attr('src', gustspd_url);
            $('.rain_hour1_url_' + device_code + ' img').attr('src', rain_hour1_url);
            $('.rain_hour24_url_' + device_code + ' img').attr('src', rain_hour24_url);
            $('.wbgt_url_' + device_code + ' img').attr('src', wbgt_url);
            /*
                        $('.windspd_bg').removeClass('alert-bg');
                        if (windspd_alert == 1) {
                            $('.windspd_bg').addClass('alert-bg');
                        }
                        $('.temp_bg').removeClass('alert-bg');
                        if (degree_alert == 1) {
                            $('.temp_bg').addClass('alert-bg');
                        }
                        $('.wbgt_bg').removeClass('alert-bg');
                        if (wbgt_alert == 1) {
                            $('.wbgt_bg').addClass('alert-bg');
                        }
                        $('.rainfall1_bg').removeClass('alert-bg');
                        if (rain_alert == 1) {
                            $('.rainfall1_bg').addClass('alert-bg');
                        }*/
        }
    });
}



/**
 * 簡易気象系コンテンツのitemId一覧を取得
 * @returns {Array}
 */
const getItemIdList = () => {
    const itemIdList = [...document.querySelectorAll('[data-simple-weather-item-id]')]
        .map(el => el.dataset.simpleWeatherItemId);

    return itemIdList
};


/**
 * エントリーポイント
 * @returns {void}
 */
const updateWeatherData = () => {
    const itemIdList = getItemIdList();

    itemIdList.forEach(itemId => {
        getWeatherData(itemId);
    })
};

/**
 * 熱中症アラート
 * @type {boolean}
 */
window.measurement_alert = false;

/**
 * 熱中症アラート
 *
 * @param itemId
 * @returns {Promise<void>}
 */
const updateHeatStrokeAlert = async (itemId) => {
    var alertContainer = $('#heatstroke_alert_' + itemId);
    var format = 'HH:mm:ss';
    var now = moment();
    var time1_start = alertContainer.find('input.alert-exclude-time1').attr('data-start1');
    var time1_end = alertContainer.find('input.alert-exclude-time1').attr('data-end1');
    var time2_start = alertContainer.find('input.alert-exclude-time2').attr('data-start2');
    var time2_end = alertContainer.find('input.alert-exclude-time2').attr('data-end2');
    var time3_start = alertContainer.find('input.alert-exclude-time3').attr('data-start3');
    var time3_end = alertContainer.find('input.alert-exclude-time3').attr('data-end3');
    if (time1_start !== '') {
        if (moment(now, format).isBetween(moment(time1_start, format), moment(time1_end, format))) {
            console.log('----動作停止時間1------');
            return;
        }
    }
    if (time2_start !== '') {
        if (moment(now, format).isBetween(moment(time2_start, format), moment(time2_end, format))) {
            console.log('----動作停止時間2------');
            return;
        }
    }
    if (time3_start !== '') {
        if (moment(now, format).isBetween(moment(time3_start, format), moment(time3_end, format))) {
            console.log('----動作停止時間3------');
            return;
        }
    }
    const response = await window.axios.get(apiDomain + '/api/simple_weather/' + itemId + '/alertStatus');
    if (response.data.alert === true) {
        var audioElement = alertContainer.find('video');
        var audioSrc = '';
        var audioOn = '';
        var alertImage = '';
        if (response.data.heat_level === 'heat_max') {
            alertImage = alertContainer.find('input.alert-image-max').val();
            audioSrc = alertContainer.find('input.alert-max').val();
            audioOn = alertContainer.find('input.alert-max-on').val();
        } else {
            alertImage = alertContainer.find('input.alert-image-max2').val();
            audioSrc = alertContainer.find('input.alert-max2').val();
            audioOn = alertContainer.find('input.alert-max2-on').val();
        }
        alertContainer.find('img').attr('src', alertImage);
        alertContainer.modal('toggle');
        audioElement.attr('src', audioSrc);
        if (audioOn === 'on') {
            audioElement.click();
        }
        window.measurement_alert = true;
        clearInterval(window.alertHeatStrokeHandler.get(itemId));
        window.alertHeatStrokeHandler.delete(itemId);
    }
};

const updateWindAverageAlert = async (itemId) => {
    const alertContainer = $('#wind_average_alert_' + itemId);
    const response = await window.axios.post(apiDomain + '/api/simple_weather/' + itemId);
    const alert_wind_continue = alertContainer.find('input.alert-wind-continue').val();
    if (response.data) {
        if (response.data.data['windspd'] > 10 && alert_wind_continue === 'on') { // 10分間の平均風速地が10mを超えた場合、アラートを出す
            if (window.measurement_alert === false) {
                alertContainer.modal('toggle');
            }
            var audioElement = alertContainer.find('audio');
            console.log('updateWindAverageAlert ====', window.measurement_alert, alert_wind_continue);
            if (window.measurement_alert === false || alert_wind_continue === 'on') {
                audioElement.click();
            }
            window.measurement_alert = true;
            if (alert_wind_continue !== 'on' && window.alertWindAverageHandler.get(itemId)) {
                clearInterval(window.alertWindAverageHandler.get(itemId));
                window.alertWindAverageHandler.delete(itemId);
            }
        }
    }

    return true;
};

const setHeatStrokeAlertInterval = () => {
    const itemIdList = getItemIdList();
    itemIdList.forEach(itemId => {
        // 熱中症アラート
        var alertDisplay = $('#alert-display-' + itemId).val();
        if (alertDisplay === 'on') {
            // 警報通知間隔(分)は、10分以上の数値
            var alertInterval = $('#heatstroke_alert_' + itemId).find('input.alert-interval').val();
            if (alertInterval < 10) {
                alertInterval = 10;
            }
            var handler = null;
            var save_interval = Cookies.get('heatstroke_alert_interval_' + itemId);
            if (save_interval !== undefined) {
                var diff_time = moment().diff(moment(save_interval, 'DD/MM/YYYY HH:mm:ss'));
                if (diff_time < alertInterval) {
                    if (window.alertHeatStrokeHandler.get(itemId) !== undefined) {
                        clearInterval(window.alertHeatStrokeHandler.get(itemId));
                        window.alertHeatStrokeHandler.delete(itemId);
                    }
                    handler = setInterval(updateHeatStrokeAlert, alertInterval - diff_time, itemId);
                } else {
                    clearInterval(window.alertHeatStrokeHandler.get(itemId));
                    window.alertHeatStrokeHandler.delete(itemId);
                    handler = setInterval(updateHeatStrokeAlert, alertInterval, itemId);
                    Cookies.set('heatstroke_alert_interval_' + itemId, moment().format('DD/MM/YYYY HH:mm:ss'), {expires: 1});
                }
            }
            else {
                handler = setInterval(updateHeatStrokeAlert, alertInterval, itemId);
                Cookies.set('heatstroke_alert_interval_' + itemId, moment().format('DD/MM/YYYY HH:mm:ss'), {expires: 1});
            }
            window.alertHeatStrokeHandler.set(itemId, handler);
        }
    });
};

const setWindAlertInterval = () => {
    // 風速計アラート
    const itemIdList = getItemIdList();
    itemIdList.forEach(itemId => {
        var handler = window.alertWindAverageHandler.get(itemId);
        if (!handler) {
            handler = setInterval(updateWindAverageAlert, 10 * 60 * 1000, itemId ); //10分
            window.alertWindAverageHandler.set(itemId, handler);
        }
    });

};

$(function () {
    $('.heatstroke-alert-close').click(function () {
        window.measurement_alert = false;
        var modal = $(this).closest('div.modal');
        modal.find('video')[0].pause();
        modal.modal('toggle');
        setHeatStrokeAlertInterval();
        // スライドのタイマーを起動する
        window.swiper.restartTimer();
    });

    $('.wind-average-alert-close').click(function () {
        window.measurement_alert = false;
        var modal = $(this).closest('div.modal');
        modal.find('audio')[0].pause();
        modal.modal('toggle');
        setWindAlertInterval();
        // スライドのタイマーを起動する
        window.swiper.restartTimer();
    });

    // 初期化
    if (!window.alertHeatStrokeHandler) {
        window.alertHeatStrokeHandler = new Map();
        setHeatStrokeAlertInterval();
        // In case has many simple weather container => only call SetInterval 1 time
        setInterval(updateWeatherData, 60000);
    }

    if (!window.alertWindAverageHandler) {
        window.alertWindAverageHandler = new Map();
        setWindAlertInterval();
    }

    var alertDisplay = $('#alert-display-' + item_id).val();
    if (alertDisplay === 'on') {
        updateHeatStrokeAlert(item_id).then(r => {});
    }

    updateWindAverageAlert(item_id).then(r => {});
});
